import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import BooleanField from 'components/show/BooleanField';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import DeleteButton from 'components/button/DeleteButton';
import ProductFieldContainer from 'components/show/ProductFieldContainer';
import MembershipScheduleFieldContainer from 'components/show/MembershipScheduleFieldContainer';
import { deleteProductMembership } from 'store/actions/product-memberships/deleteProductMembership';

const ProductMembershipShow = (props) => {
    const {
        id,
        history,
        record,
        resource,
        translate,
    } = props;

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.product_memberships'),
            link: '/product-memberships',
        },
        {
            label: record.name,
        },
    ];

    const onDeleteMembership = () => {
        return deleteProductMembership({
            id,
            onSuccess: () => {
                return history.push('/product-memberships');
            },
        });
    };

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ record.name }/>

                <Actions>
                    <EditButton
                        icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                        url={ `/${ resource }/${ id }` }
                    />

                    <DeleteButton action={ onDeleteMembership } record={ record } />
                </Actions>
            </Header>

            <Section>
                <Column title={ translate('resources.discounts.forms.general') }>
                    <InnerColumn>

                        <TextField
                            label={ translate('filters.components.name.label') }
                            value={ record.name }
                        />

                        <BooleanField
                            label={ translate('resources.products.fields.is_visible') }
                            value={ record.is_visible || false }
                        />
                    </InnerColumn>
                </Column>
                <Column title={ translate('resources.subscriptionProducts.fields.product') }>
                    <InnerColumn>
                        <ProductFieldContainer id={ record.product_id } />
                    </InnerColumn>
                </Column>
            </Section>
            <Section>
                <Column title={ translate('resources.product_memberships.fields.membership_schedule') }>
                    <InnerColumn>
                        <MembershipScheduleFieldContainer id={ record.membership_schedule_id } />
                    </InnerColumn>
                </Column>
            </Section>
            <Section>
                <Column title={ translate('resources.users.memberships.pricing') }>
                    <InnerColumn>
                        <BooleanField
                            label={ translate('resources.product_memberships.fields.supports_ondemand') }
                            value={ record.supports_ondemand || false }
                        />
                        <TextField
                            label={ translate('fields.currency') }
                            value={ record.currency }
                        />

                        <TextField
                            label={ translate('fields.price') }
                            value={ record.price_ondemand ? record.price_ondemand.toFixed(2) : null }
                        />
                    </InnerColumn>
                    <InnerColumn>
                        <BooleanField
                            label={ translate('resources.product_memberships.fields.supports_scheduled') }
                            value={ record.supports_scheduled || false }
                        />
                        <TextField
                            label={ translate('fields.currency') }
                            value={ record.currency }
                        />

                        <TextField
                            label={ translate('fields.price') }
                            value={ record.price_scheduled ? record.price_scheduled.toFixed(2) : null }
                        />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

ProductMembershipShow.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
    id: PropTypes.number,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductMembershipShow);



// WEBPACK FOOTER //
// ./src/pages/product-memberships/show/ProductMembershipShow.js